//import Headroom from "headroom.js";



var $device;
/*
* dispatcher 全ページ共通
*/
dispatcher('.', function () {

    (function () {
        //var headroom;



        /*
        *	メディアクエリー
        */
        const mediaQueryList = window.matchMedia('(min-width:922px)');

        const ScreenListener = (event) => {
          // リサイズ時に行う処理
          if (event.matches) {
            // 922px以上
            $device = 'pc';
            //console.log( $device );
            
            /*
            //headroom
            var headroomElement = document.getElementById('masthead');
            var headroomOptions = {
                tolerance : {up: 10,down: 10},
                onUnpin : function() {
                    
                }
            };
        
            headroom = new Headroom(headroomElement, headroomOptions);
            headroom.init();
            */

          } else {
            
            // 922px未満
            $device = 'sp';
            //console.log( $device );

            /*
            // headroom解除
            if( headroom !== undefined ){
                headroom.destroy();
            }
            */
          }
        };
        
        // リスナー登録
        mediaQueryList.addListener( ScreenListener );
        
        // 初期化処理
        ScreenListener( mediaQueryList );


        /*
        * メニューボタン
        */
        
        //メニュートグル
        const trigger = document.getElementById('menu-toggle');
        

        if ( trigger ) {
            trigger.addEventListener('click', () => {
                //const target = document.getElementById('page');
                const $body = document.getElementsByTagName('body')[0];
                $body.classList.toggle('is-open');                
            }, false);
        }

    })();

});

// 第一引数はURLのパス部分にマッチする正規表現 
dispatcher('^/contact/$', function () {
    (function () {
        document.addEventListener('DOMContentLoaded', function () {

            
            

            // $modifyが1（内容を修正する）の時はプライバシーチェックをオンにする
            if( $wpform.modify == '1' ){
                var privacyCheck = document.getElementById('privacy-accept-check');
                privacyCheck.checked = true;
            }
            toggleSend();
            
            

            
            
            
            

            // チェックボックスに 'change' イベントリスナーを追加
            document.getElementById('privacy-accept-check').onchange = toggleSend;
          }, false);

          function toggleSend() {
            var privacyCheck = document.getElementById('privacy-accept-check');
            //console.log( 'checked:' + privacyCheck.checked );
            //console.log( 'value:' + privacyCheck.value );
            //console.log( 'modify:' + $wpform.modify );
            // 請求先のテキストフィールドを選択
            var sendBtn = document.querySelectorAll('input[type="submit"]');
          
            // 請求先テキストフィールドを切り替え
            if( privacyCheck.checked === true ){
                for (var i = 0; i < sendBtn.length; i++) {
                    sendBtn[i].disabled = false;//!sendBtn[i].disabled;
                }
            }else{
                for (var i = 0; i < sendBtn.length; i++) {
                    sendBtn[i].disabled = true;//!sendBtn[i].disabled;
                }
            }
            
          }

        
    })();
});





/*	function dispatcher
*	URLパスに応じて実行スクリプトを制御
*	第一引数はURLのパス部分にマッチする正規表現
*/
function dispatcher (path, func) {
    dispatcher.path_func = dispatcher.path_func || []
    if (func) return dispatcher.path_func.push([path, func]);
    for(var i = 0, l = dispatcher.path_func.length; i < l; ++i) { // >
        var func = dispatcher.path_func[i];
        var match = path.match(func[0]);
        match && func[1](match);
    };
};
dispatcher(location.pathname);